import PropTypes from "prop-types";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Send } from "lucide-react";
import { TelegramConnectForm, useTelegramConfigure } from "@/components/connections/TelegramConnectPanel";

export function TelegramConfigureDialog({
  open,
  onOpenChange,
  connectionId,
  ensureConnection,
  canEdit,
  onConfigured,
}) {
  const tg = useTelegramConfigure({
    connectionId,
    ensureConnection,
    canEdit,
    onConfigured: async (r) => {
      await onConfigured?.(r);
      if (r?.openclaw_synced !== false && r?.status !== "sync_failed") {
        onOpenChange(false);
      }
    },
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-[520px]"
        data-testid="telegram-configure-dialog"
        preventOutsideDismiss
      >
        <DialogHeader>
          <DialogTitle className="inline-flex items-center gap-2">
            <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-cyan-100">
              <Send size={15} className="text-cyan-700" />
            </span>{" "}
            Connect Telegram
          </DialogTitle>
          <DialogDescription className="text-[12px]">
            Enter a BotFather token to connect or replace the current bot so your agent can receive and respond to Telegram messages.
          </DialogDescription>
        </DialogHeader>
        {open && (
          <TelegramConnectForm tg={tg} canEdit={canEdit} testIdPrefix="settings-telegram" />
        )}
      </DialogContent>
    </Dialog>
  );
}

TelegramConfigureDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  connectionId: PropTypes.string,
  ensureConnection: PropTypes.func,
  canEdit: PropTypes.bool,
  onConfigured: PropTypes.func,
};
